/* Desktop header dropdown: keyboard + WCAG-friendly focus behavior */
(function () {
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isTabKey(e) {
    var key = e.key || e.keyCode;
    return key === 'Tab' || key === 9;
  }

  function closest(el, sel) {
    if (!el) return null;
    if (el.closest) return el.closest(sel);
    while (el) {
      if (el.matches && el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function getIndex(el) {
    if (!el || !el.getAttribute) return null;
    var idx = el.getAttribute('data-dropdown-index');
    return idx ? String(idx) : null;
  }

  function setExpanded(el, expanded) {
    if (!el || !el.setAttribute) return;
    el.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function removeClassAll(sel, className) {
    qsa(sel).forEach(function (el) {
      el.classList.remove(className);
    });
  }

  function closeDropdown() {
    removeClassAll('.header--dropdown.active', 'active');
    removeClassAll('.header--dropdown_group.active', 'active');

    qsa('.nav--primary_link.open').forEach(function (el) {
      setExpanded(el, false);
      el.classList.remove('open');
    });
  }

  function getTopLinkByIndex(idx) {
    if (!idx) return null;
    return document.querySelector('.header--nav .nav--primary_link[data-dropdown-index="' + idx + '"]');
  }

  function getDropdownGroupByIndex(idx) {
    if (!idx) return null;
    return document.querySelector('.header--dropdown_group[data-dropdown-index="' + idx + '"]');
  }

  function getFocusableEls(root) {
    if (!root) return [];
    // Dropdown is links; keep generic for safety.
    return qsa('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])', root).filter(function (el) {
      // Ignore hidden elements.
      if (el.offsetParent === null && getComputedStyle(el).position !== 'fixed') return false;
      return true;
    });
  }

  function getNextTopLink(currentLink) {
    var links = qsa('.header--nav .nav--primary_link');
    var i = links.indexOf(currentLink);
    if (i < 0) return null;
    return links[i + 1] || null;
  }

  function openDropdownFor(linkEl) {
    var idx = getIndex(linkEl);
    if (!idx) {
      closeDropdown();
      return;
    }

    qsa('.header--dropdown_group.active').forEach(function (el) {
      el.classList.remove('active');
    });

    qsa('.header--dropdown').forEach(function (el) {
      el.classList.add('active');
    });

    qsa('.header--dropdown_group[data-dropdown-index="' + idx + '"]').forEach(function (el) {
      el.classList.add('active');
    });

    qsa('.nav--primary_link.open').forEach(function (el) {
      setExpanded(el, false);
      el.classList.remove('open');
    });

    linkEl.classList.add('open');
    setExpanded(linkEl, true);
  }

  function focusIsInHeaderMenu() {
    var el = document.activeElement;
    return !!closest(el, '.header--nav, .header--dropdown');
  }

  // Capture focusin so it works reliably across bubbling edge-cases.
  document.addEventListener(
    'focusin',
    function (e) {
      var link = closest(e.target, '.header--nav .nav--primary_link');
      if (!link) return;
      openDropdownFor(link);
    },
    true
  );

  document.addEventListener(
    'focusout',
    function () {
      window.setTimeout(function () {
        if (!focusIsInHeaderMenu()) closeDropdown();
      }, 0);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (e) {
      var target = e.target;
      var topLink = closest(target, '.header--nav .nav--primary_link');
      var dropdownLink = closest(target, '.header--dropdown a');
      if (!topLink && !dropdownLink) return;

      var key = e.key || e.keyCode;
      if (key === 'Escape' || key === 'Esc' || key === 27) {
        closeDropdown();
        if (target && target.focus) target.focus();
        return;
      }

      // Critical: Tab order should move into dropdown items.
      if (isTabKey(e) && topLink) {
        var idx = getIndex(topLink);
        if (!idx) return; // no dropdown
        var group = getDropdownGroupByIndex(idx);
        if (!group || !group.classList.contains('active')) return;

        if (!e.shiftKey) {
          var focusables = getFocusableEls(group);
          if (focusables.length) {
            e.preventDefault();
            focusables[0].focus();
          }
        }
        return;
      }

      if (isTabKey(e) && dropdownLink) {
        var groupEl = closest(dropdownLink, '.header--dropdown_group');
        if (!groupEl) return;
        var idx2 = groupEl.getAttribute('data-dropdown-index');
        var focusables2 = getFocusableEls(groupEl);
        if (!focusables2.length) return;
        var first = focusables2[0];
        var last = focusables2[focusables2.length - 1];

        // Shift+Tab from first dropdown item -> back to top-level link.
        if (e.shiftKey && dropdownLink === first) {
          var parentLink = getTopLinkByIndex(idx2);
          if (parentLink) {
            e.preventDefault();
            parentLink.focus();
          }
          return;
        }

        // Tab from last dropdown item -> close + move to next top-level link.
        if (!e.shiftKey && dropdownLink === last) {
          var parentLink2 = getTopLinkByIndex(idx2);
          var nextLink = parentLink2 ? getNextTopLink(parentLink2) : null;
          if (nextLink) {
            e.preventDefault();
            closeDropdown();
            nextLink.focus();
          } else {
            // No next menu item: close and allow natural tabbing onward.
            window.setTimeout(closeDropdown, 0);
          }
        }
      }
    },
    true
  );
})();